import { ref, onMounted } from 'vue'

export default function useUrl() {
  const params = ref({})

  function react() {
    // React to URL parameters - implement specific logic as needed
    const urlParams = new URLSearchParams(window.location.search)
    params.value = Object.fromEntries(urlParams)
  }

  function updateUrl(newParams) {
    const url = new URL(window.location)
    Object.entries(newParams).forEach(([key, value]) => {
      if (value) {
        url.searchParams.set(key, value)
      } else {
        url.searchParams.delete(key)
      }
    })
    window.history.replaceState({}, '', url)
  }

  onMounted(() => {
    react()
  })

  return {
    params,
    react,
    updateUrl,
  }
}
